<script>
import PositionForm from '@views/quotes/positions/position-form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEditModal';

export default {
  components: {
    PositionForm,
  },
  mixins: [beforeLeaveAfterEdit],
  props: {
    value: {
      type: Number,
      default: null,
    },
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
    // eslint-disable-next-line
    quote: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    },
  },
  methods: {
    submit(quotePosition) {
      this.setUnchanged();
      this.$emit('updated', quotePosition);
    },
    remove() {
      this.setUnchanged();
      this.showModal = false;
      this.$emit('deleted');
    },
    hide(bvEvt) {
      this.beforeModalClose(bvEvt, () => {
        this.setUnchanged();
        this.$refs.positionModal.hide();
      });
    },
  },
};
</script>

<template>
  <b-modal
    ref="positionModal"
    v-model="showModal"
    size="lg"
    hide-footer
    :title="$t('titles.edit_quote_position')"
    static
    @hide="hide"
    @hidden="$emit('hidden')"
  >
    <PositionForm v-if="showModal" :loaded-id="loadedId" :quote="quote" @submitted="submit" @deleted="remove" @entity-changed="initBeforeLeave" />
  </b-modal>
</template>
